<template>
	<div class="container">
		<div v-show="showTooltip" ref="tooltip" class="tooltip">{{ tooltip }}</div>
		<h1>Generate link</h1>

		<form @submit.prevent="handleSubmit">
			<label>
				<span>iOS native app link</span>
				<input ref="ios" v-model="ios" type="text" />
			</label>
			<label>
				<span>Android native app link</span>
				<input ref="android" v-model="android" type="text" />
			</label>
			<label>
				<span>Web link</span>
				<input
					ref="web"
					v-model="web"
					type="text"
					:class="{ invalid: web.length > 0 && isValidated && !validation }"
					@keyup="validateUrl(web)"
				/>
			</label>
			<p v-show="error.length > 0" class="error">{{ error }}</p>

			<button type="submit" :disabled="!isValidated || ios.length < 1 || android.length < 1 || web.length < 1">Generate link</button>
		</form>

		<p
			v-show="link"
			class="link"
			@click="copyToClipboard"
			@mouseover="showTooltip = true"
			@mouseout="
				showTooltip = false
				tooltip = 'Kopier til udklipsholder'
				$refs.tooltip.style = ''
			"
		>
			{{ link }}
		</p>
	</div>
</template>

<script>
export default {
	name: 'GenerateLink',
	data() {
		return {
			ios: '',
			android: '',
			web: '',
			link: '',
			isValidated: false,
			validation: false,
			error: '',
			showTooltip: false,
			tooltip: 'Kopier til udklipsholder'
		}
	},
	mounted() {
		document.addEventListener('mousemove', this.moveTooltip)
		this.$once('hook:destroyed', () => {
			document.removeEventListener('mousemove', this.moveTooltip)
		})
	},
	methods: {
		moveTooltip(e) {
			this.$refs.tooltip.style.left = `${e.clientX + 20}px`
			this.$refs.tooltip.style.top = `${e.clientY - 20}px`
		},
		handleSubmit() {
			if (this.ios.length < 1 || this.android.length < 1 || this.web.length < 1) return (this.error = 'Udfyld alle links!')
			if (!this.validation) return (this.error = 'Angiv et gyldigt Web URL.')
			this.error = ''

			const iosLink = encodeURIComponent(this.ios)
			const androidLink = encodeURIComponent(this.android)
			const webLink = encodeURIComponent(this.web)

			const paramsObj = {
				ios: iosLink,
				android: androidLink,
				web: webLink
			}

			const params = new URLSearchParams(paramsObj).toString()

			this.link = `${window.location.origin}/link?${params}`
		},
		async copyToClipboard() {
			try {
				await navigator.clipboard.writeText(this.link)
				this.tooltip = 'Link kopieret! ✔'
			} catch ($e) {
				alert('Linket kunne ikke kopieres til udklipsholder')
			}
		},
		validateUrl(str) {
			this.isValidated = true
			if (!str.startsWith('https://') && !str.startsWith('http://')) return (this.validation = false)
			try {
				const url = new URL(str)
				return (this.validation = !!url)
			} catch (err) {
				return (this.validation = false)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.container {
	word-break: break-word;
}
.tooltip {
	position: absolute;
	top: 0;
	left: 0;
	border: 2px solid #00becd;
	border-radius: 5px;
	padding: 6px 12px;
	background: #fff;
	z-index: 10;
}
.error {
	color: red;
}
form {
	display: flex;
	flex-direction: column;
	max-width: 600px;
}
label,
input {
	display: block;
	width: 100%;
}
input {
	border: 2px solid #00becd;
	border-radius: 5px;
	outline: none;
}
.link {
	cursor: pointer;
}
.invalid {
	border: 2px solid red;
}
button {
	background: #00becd;
	color: #fff;
	border: 2px solid #00becd;
	border-radius: 5px;
	outline: none;
	margin: 1rem 0;
	padding: 0.25rem 1rem;
	cursor: pointer;
	transition: 250ms ease-in-out;

	&:disabled {
		background-color: #bbb;
		border-color: #bbb;
		cursor: not-allowed;
	}
}
</style>
